import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Avatar from '../Avatar';
import AssetIcon from './AssetIcon';

class AssetImage extends React.Component {
    render() {
        const { isSelected, visualizationType, classes } = this.props;

        const checkbox = isSelected ? (
            <Avatar className={classes.selectedAvatar}>
                <i className={classes.checkIcon}>check</i>
            </Avatar>
        ) : (
            <Avatar className={classes.unselectedAvatar}>
                <i className="material-icons">check_box_outline_blank</i>
            </Avatar>
        );

        return (
            <div className={classes.container}>
                <div className={classes.checkboxContainer}>
                    {checkbox}
                </div>
                <div className={classes.iconContainer}>
                    <AssetIcon visualizationType={visualizationType} />
                </div>
            </div>
        );
    }
}

AssetImage.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    visualizationType: PropTypes.string.isRequired,
    anySelected: PropTypes.bool,
};

AssetImage.defaultProps = {
    anySelected: false,
};

const style = ({ palette }) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        minHeight: '40px',
        minWidth: '60px',
    },
    checkboxContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '20px',
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '40px',
    },
    selectedAvatar: {
        transition: 'all 0.2s ease-in-out',
        background: palette.primary.main,
        height: '20px',
        width: '20px',
        animation: 'avatar-select 0.2s ease-in-out',
    },
    unselectedAvatar: {
        transition: 'all 0.2s ease-in-out',
        background: 'transparent',
        border: `2px solid #8b8b8b`,
        height: '15px',
        width: '15px',
        '&:hover': {
            transform: 'scale(1.1)',
            border: `2px solid ${palette.primary.main}`,
        },
    },
    checkIcon: {
        composes: 'material-icons',
        fontSize: '15px',
        animation: 'checkmark-appear 0.2s ease-in-out',
    },
    '@keyframes checkmark-appear': {
        '0%': {
            opacity: 0,
            transform: 'scale(0.5)',
        },
        '100%': {
            opacity: 1,
            transform: 'scale(1)',
        },
    },
    '@keyframes avatar-select': {
        '0%': {
            transform: 'scale(0.8)',
        },
        '50%': {
            transform: 'scale(1.2)',
        },
        '100%': {
            transform: 'scale(1)',
        },
    },
});

export default injectSheet(style)(AssetImage); 



// WEBPACK FOOTER //
// ./src/components/assets/AssetImage.js